import React, {useRef} from "react";
import {Card, Col, Form, Row, Button} from "react-bootstrap";
import {useFormik} from "formik";
import Editor from "@monaco-editor/react";
import {useNavigate} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {useDispatch} from "react-redux";
import {Container} from "react-bootstrap";
import * as Yup from "yup";
import * as monaco from "monaco-editor";
import {addBlockList as createNewBlock} from "../../slices/block/thunk";

const CreateBlock = () => {
    document.title = "Create block";
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const editorRef = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
            url: '',
            status: 'ENABLE',
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Your Product Name"),
            url: Yup.string().required("Please Enter Your Category Image"),
        }),

        onSubmit: async (values) => {
            const data = {
                title: values.title,
                content: editorRef.current ? editorRef.current.getValue() : "",
                url: values.url,
                type: "BLOCK",
            }

            dispatch(createNewBlock(data))
                .unwrap()
                .then((data: any) => {
                    if (data.id) {
                        navigate(`/edit-block?id=${data?.id}`)
                    }
                })
                .catch((err: any) => {
                    console.error("Xato:", err);
                });
        }
    });

    const clearContent = () => {
        formik.resetForm({
            values: {
                title: '',
                url: '',
                status: 'ENABLE',
            }
        });
        if (editorRef.current) {
            editorRef.current.setValue("");
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form autoComplete="off" onSubmit={formik.handleSubmit} className={"container-fluid m-auto"}>
                        <Row>
                            <Col xxl={8}>
                                <Card>
                                    <Card.Header>
                                        <Card.Title as="h5" className="mb-3">Block Information:</Card.Title>
                                        <hr/>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="title">Title <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="title"
                                                name="title"
                                                placeholder="title"
                                                value={formik.values.title}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.title}/>
                                            {formik.errors.title && formik.touched.title ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.title}</Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Form.Label htmlFor="url">URL <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="url"
                                                name="url"
                                                placeholder="url"
                                                value={formik.values.url}
                                                onChange={(e) => {
                                                    let newValue = e.target.value
                                                        .replace(/['"@#$%&*\+/`~‘\s]/g, '')
                                                        .slice(0, 60);
                                                    formik.setFieldValue("url", newValue);

                                                }}
                                                onBlur={formik.handleBlur}
                                                onFocus={() => {
                                                    if (!formik.values.url) {
                                                        let res = formik.values.title.toLowerCase();
                                                        let res1 = res.replace(/['"@#$%&*-+/`~‘’]/g, '');
                                                        let res2 = res1.replace(/\s+/g, '-');
                                                        res2 = res2.substring(0, 60);
                                                        formik.setFieldValue("url", res2);
                                                    }
                                                }}
                                                isInvalid={!!formik.errors.url}
                                            />
                                            {formik.errors.url && formik.touched.url ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.url}</Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Card.Body>
                                </Card>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className="mb-3">Code:</Card.Title>
                                        <Editor
                                            height="500px"
                                            defaultLanguage="html"
                                            defaultValue=""
                                            theme="vs-light"
                                            onMount={(editor) => (editorRef.current = editor)}
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xxl={4}>
                                <Card>
                                    <Card.Header>
                                        <Card.Title className="mb-3">Details:</Card.Title>
                                        <hr/>
                                    </Card.Header>
                                    <Card.Body>

                                        <div className="mb-3">
                                            <Form.Label
                                                htmlFor="blockStatusd">Status</Form.Label>
                                            <Form.Select
                                                id="blockStatusd"
                                                name="status"
                                                value={formik.values.status}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.status}>
                                                <option value="ENABLE">Enable</option>
                                                <option value="DISABLE">Disabled</option>
                                                <option value="BLOCKED">Blocked</option>
                                                <option value="PUBLISHED">published</option>
                                                <option value="DRAFT">draft</option>
                                            </Form.Select>
                                            {formik.errors.status && formik.touched.status ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.status} </Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                    </Card.Body>
                                    <Card.Footer>
                                        <div className="hstack justify-content-between mb-3">
                                            <Button variant="danger" onClick={clearContent}>
                                                <i className="ph-x align-middle"></i> Cancel
                                            </Button>
                                            <Button type={"submit"} variant="primary">
                                                Create block
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
            <ToastContainer/>
        </React.Fragment>
    )
}

export default CreateBlock;